import React, { lazy } from 'react';

const MultiTag = lazy(() => import('.'));

const routes = [
  {
    path: '/multi-tag',
    element: <MultiTag />,
    title: 'Multi Tag'
  }
];

export default routes;
